<template>
   <div id="service-center-container">
      <b-tabs type="is-boxed" :animated="false" v-model="tab" :key="refresher">
         <!-- REQUEST SECTION -->
         <b-tab-item>
            <template #header>
               {{ $t("serviceCenterComponent_tabServiceCenterRequestForm_label") }}
            </template>
            <ServiceCenterRequestForm :order-id="orderId" :packages="packages" :tasklist="taskListControlls" :ancillaryChoices="AncilaryChoicesMap" />
         </b-tab-item>

         <!-- MY NOTES SECTION -->

         <b-tab-item v-if="showTask">
            <template #header>
               {{ $t("serviceCenterComponent_tabTaskChat_label") }}
            </template>
            <TaskChat :order-id="orderId" @show-task="handlerHideTask" />
         </b-tab-item>

         <!-- CHAT SECTION -->
         <b-tab-item>
            <template #header>
               {{ $t("serviceCenterComponent_tabMyNotes_label") }}
            </template>
            <Notes :order-id="orderId" />
         </b-tab-item>

         <!-- Change Details -->

         <b-tab-item v-if="showChangeDetails">
            <template #header>
               {{ $t("serviceCenterComponent_tabChangeDetails_label") }}
               <!-- {{ $t("serviceCenterComponent_tabChangeDetails_label") }} -->
            </template>

            <ChangeDetails :taskIds="taskIds" />
         </b-tab-item>
      </b-tabs>
   </div>
</template>

<script>
import { notesService } from "@/service/index.js";
import ServiceCenterRequestForm from "@/components/unitary/order/ServiceCenter/RequestForm.vue";
import TaskChat from "@/components/unitary/order/ServiceCenter/TaskChat.vue";
import ChangeDetails from "@/components/unitary/order/ServiceCenter/ChangeDetails.vue";
import Notes from "@/components/unitary/order/ServiceCenter/Notes.vue";

export default {
   name: "ServiceCenter",
   props: {
      packages: Object,
      orderId: [Number, String],
      ancillaryChoices: Array,
   },
   components: {
      ServiceCenterRequestForm,
      TaskChat,
      ChangeDetails,
      Notes,
   },
   data() {
      return {
         refresher: 1,
         tab: 0,
         showTask: false,
         showChangeDetails: false,
         taskIds: [],
         taskListControlls: null,
      };
   },
   mounted() {},
   computed: {
      AncilaryChoicesMap() {
         return this.ancillaryChoices.reduce((acc, item) => {
            acc[item.pnr.id] = item.ancillaryChoices;
            return acc;
         }, {});
      },
   },
   methods: {
      refreshTabs() {
         this.refresher++;
      },
      handlerHideTask(showtask) {
         const self = this;
         this.tab = 1;
         self.showTask = showtask;
      },
      handlerTaskListControll(list) {
         const self = this;
         self.taskListControlls = list;
      },
   },
   watch: {
      orderId: {
         handler: function (orderId) {
            if (orderId != 0) {
               notesService.listTasks({ orderId: this.orderId }).then((res) => {
                  if (res.result.success) {
                     this.taskIds = res.tasks
                        .filter((task) => {
                           if (task.type == 11) {
                              this.showChangeDetails = true;
                              this.$store.commit("flight/setFlightChangeWarning", true);
                              return true;
                           }
                           this.showTask = true;
                           return false;
                        })
                        .map((task) => task.id);
                  }
               });
            }
         },
      },
      showTask: {
         handler: function (status) {
            this.refreshTabs();
            if (status || this.$router.history.current.query.taskopen) {
               this.tab = 1;
            } else {
               this.tab = 0;
            }
         },
         immediate: true,
      },
      // showTask: {
      //    handler: function (status) {
      //       this.refreshTabs();
      //       if (status && this.$router.history.current.query.taskopen) {
      //          this.tab = 1;
      //       }
      //    },
      // },
      showChangeDetails: {
         handler: function (status) {
            this.refreshTabs();

            if (status && this.$router.history.current.query.flightchange) {
               setTimeout(() => {
                  this.tab = 5;
               }, 2000);
            }
         },
         immediate: true,
      },
   },
};
</script>

<style lang="scss" scoped>
#service-center-container {
   margin: 2rem 0;
}
</style>

<style lang="scss">
#service-center-container > .b-tabs > .tabs > ul {
   margin-bottom: -3px;
}
#service-center-container > .b-tabs > .tabs > ul > li > a {
   font-weight: 500;
   color: var(--gray-500);
   background-color: var(--gray-100) !important;
   margin: 0 0.5rem;

   &:first-child {
      margin-left: 0;
   }
}

#service-center-container > .b-tabs > .tab-content {
   padding: 0 !important;
}

#service-center-container > .b-tabs > .tabs > ul > li.is-active > a {
   color: var(--gray-700) !important;
   background-color: var(--container-bg) !important;
   font-size: var(--large);
   border: none !important;
}
</style>
